import AppTheme from '../../../theme/AppTheme';
import { Box } from '@mui/material';
import LogoSwitchComponent from './logo_switch';
import NavigationComponent from './navigation';
import { RootState } from '../../../redux/store';
import { styled } from '@mui/material/styles';
import UserProfileSettingsComponent from './user_profile_settings';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
/**
 * @heading1: Header Component
 * @block_quotes: A reusable Header component.
 * @heading3: Styled Components
 * @heading4: Styled header
 * @block_quotes: header styles has been added
 */
const StyledHeader = styled('header')(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? 'black' : 'white',
    width: '100%',
    boxSizing: 'border-box',
    borderBottom: '1px solid #f4f4f4',
    height: 'max-content'
}));

/**
 * @heading2: Header Component
 * @block_quotes: A reusable Header field component.
 */
const HeaderComponent: React.FC = (props: { disableCustomTheme?: boolean }) => {
    const { currentUser } = useSelector((state: RootState) => state.app);
    const [selectedPage, setSelectedPage] = useState('dashboard');

    return (
        <AppTheme {...props}>
            <StyledHeader role="banner">
                <Box
                    width="100%"
                    margin="0 auto"
                    padding="20px 16px"
                    display="flex"
                    boxSizing="border-box"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <LogoSwitchComponent setSelectedpage={(value: string) => setSelectedPage(value)} />
                    {(currentUser?.role === 'companyManager' || currentUser?.role === 'organizationAdmin' || currentUser?.role === 'organizationOwner' || currentUser?.role === 'salesManager' || currentUser?.role === 'salesMember') && <NavigationComponent setSelectedpage={(value: string) => setSelectedPage(value)} selectedPage={selectedPage} />}
                    <UserProfileSettingsComponent />
                </Box>
            </StyledHeader>
        </AppTheme>
    );
};
export default HeaderComponent;
